/** Stable snapshot for rows that are not the drag source or drop target. */
export const OFF_DRAG_SNAPSHOT = Object.freeze({ isDragging: false, dropIntent: null });

const intentEqual = (a, b) =>
    (a?.targetId ?? null) === (b?.targetId ?? null) &&
    a?.label === b?.label &&
    a?.valid === b?.valid &&
    a?.reason === b?.reason;

class TaskDragUiStore {
    constructor() {
        this.listeners = new Set();
        this.activeDragId = null;
        this.dropIntent = null;
        this.rowSnapshots = new Map();
    }

    subscribe = listener => {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    };

    emit() {
        this.listeners.forEach(listener => listener());
    }

    getRowSnapshot(taskId) {
        const id = String(taskId);
        const isDragging = this.activeDragId === id;
        const isTarget = this.dropIntent?.targetId === id;

        if (!isDragging && !isTarget) {
            return OFF_DRAG_SNAPSHOT;
        }

        const dropIntent = isTarget ? this.dropIntent : null;
        const cached = this.rowSnapshots.get(id);
        if (cached && cached.isDragging === isDragging && cached.dropIntent === dropIntent) {
            return cached;
        }

        const snapshot = { isDragging, dropIntent };
        this.rowSnapshots.set(id, snapshot);
        return snapshot;
    }

    setActiveDragId(id) {
        const next = id != null ? String(id) : null;
        if (this.activeDragId === next) return;
        this.activeDragId = next;
        this.rowSnapshots.clear();
        this.emit();
    }

    setDropIntent(intent) {
        if (intentEqual(this.dropIntent, intent)) return;
        this.dropIntent = intent;
        this.rowSnapshots.clear();
        this.emit();
    }

    clear() {
        if (this.activeDragId == null && this.dropIntent == null) return;
        this.activeDragId = null;
        this.dropIntent = null;
        this.rowSnapshots.clear();
        this.emit();
    }
}

export const taskDragUiStore = new TaskDragUiStore();
